export default __webpack_public_path__ + "static/media/TC.781357eb.svg";